import { jsx, jsxs } from 'react/jsx-runtime';
import { useLocalization } from '@shared-ui/localization-context';
import * as React from 'react';
import '../../button/button/index.esm.js';
import { EGDSPrimaryButton } from '../../button/primary-button/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSTertiaryButton } from '../../button/tertiary-button/index.esm.js';
import '../../button/paging-button/index.esm.js';
import { EGDSIcon, EGDSIconSize } from '../../icons/icon/index.esm.js';
import '../../layout-flex/types/index.esm.js';
import { EGDSLayoutFlex } from '../../layout-flex/layout-flex/index.esm.js';
import { EGDSLayoutFlexItem } from '../../layout-flex/layout-flex-item/index.esm.js';
import '../../spacing/types/index.esm.js';
import { EGDSSpacing } from '../../spacing/spacing/index.esm.js';
import '../../spacing/spacing-hr/index.esm.js';
import { EGDSCalendar } from '../calendar/index.esm.js';
import '../date-field/index.esm.js';
import '../date-picker/index.esm.js';
import '../day/index.esm.js';
import '../month/index.esm.js';
import { EGDSDatePickerInput } from '../date-picker-input/index.esm.js';
import '../date-picker-dialog-view/index.esm.js';
import styles from '../../styles/uitk-egds-date-picker.css';
import { liveAnnounce } from '../../utils/live-announce/index.esm.js';
import { isElementVisible } from '../../utils/is-element-visible/index.esm.js';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
class DatePickerMenuView extends React.Component {
  static displayName = 'EGDSDatePickerMenuView';
  elementRef;
  constructor(props) {
    super(props);
    this.elementRef = React.createRef();
    this.state = {
      displayDate: undefined,
      localizedText: {
        cancelButton: () => props.l10n.formatText('datePicker.cancelButton.a11yLabel'),
        datePickerOpened: () => props.l10n.formatText('datePicker.datePickerOpened.liveAnnounce'),
        doneButtonFare: (nights, lowestFareMessage, startDate, endDate) => {
          if (nights <= 1) {
            return props.l10n.formatText('datePicker.doneButtonFareWithSummary.single.a11yLabel', startDate, lowestFareMessage);
          }
          return props.l10n.formatText('datePicker.doneButtonFareWithSummary.multiple.a11yLabel', startDate, endDate, lowestFareMessage);
        },
        clearInstructions: () => props.l10n.formatText('datePicker.clearInstructions.a11yLabel'),
        doneInstructions: () => props.l10n.formatText('datePicker.doneInstructions.a11yLabel'),
        hiddenDoneButton: (nights, startDate, endDate) => {
          if (nights <= 1) {
            return props.l10n.formatText('datePicker.doneButtonWithSummary.single.a11yLabel', startDate);
          }
          return props.l10n.formatText('datePicker.doneButtonWithSummary.multiple.a11yLabel', startDate, endDate);
        }
      }
    };
    this.onClickTopStart = this.onClickTopStart.bind(this);
    this.onClickTopEnd = this.onClickTopEnd.bind(this);
    this.onSubmitDates = this.onSubmitDates.bind(this);
    this.onChangeMonth = this.onChangeMonth.bind(this);
    this.onChangeStartDate = this.onChangeStartDate.bind(this);
    this.onChangeEndDate = this.onChangeEndDate.bind(this);
    this.clearDisplayDate = this.clearDisplayDate.bind(this);
    this.focusOnElement = this.focusOnElement.bind(this);
    this.hiddenDoneButton = this.hiddenDoneButton.bind(this);
  }
  componentDidMount() {
    const {
      formattedStartSelection,
      labels,
      preventAutoFocus,
      startSelectedMsg
    } = this.props;
    const {
      localizedText
    } = this.state;
    if (this.elementRef && this.elementRef.current) {
      const startInputRef = this.elementRef.current.getElementsByTagName('button')[0];
      if (!preventAutoFocus) {
        this.focusOnElement(startInputRef);
      }
    }
    const datePickerOpenedString = localizedText.datePickerOpened();
    liveAnnounce(`${datePickerOpenedString}, 
      ${formattedStartSelection} ${labels.start} ${startSelectedMsg}`);
  }
  shouldComponentUpdate(nextProps) {
    const {
      selection
    } = this.props;
    if (nextProps && nextProps.holidays && nextProps.holidays.length > 0) {
      selection.configureHolidays(nextProps.holidays);
    }
    return true;
  }
  onClickTopStart() {
    const {
      onSelectStartMode,
      selection
    } = this.props;
    this.setState({
      displayDate: selection.start
    });
    onSelectStartMode();
  }
  onClickTopEnd() {
    const {
      onSelectEndMode,
      selection
    } = this.props;
    this.setState({
      displayDate: selection.end
    });
    onSelectEndMode();
  }
  onSubmitDates() {
    const {
      onSubmit,
      onDoneButtonClickCB
    } = this.props;
    if (onDoneButtonClickCB) {
      const {
        selection
      } = this.props;
      const {
        start,
        end
      } = selection;
      onDoneButtonClickCB(start, end);
    } else {
      onSubmit();
    }
  }
  onChangeMonth(month) {
    const {
      onChangeMonth
    } = this.props;
    if (onChangeMonth) {
      onChangeMonth(month, false);
    }
  }
  onChangeStartDate(date) {
    const {
      onChangeStartDate
    } = this.props;
    if (onChangeStartDate) {
      onChangeStartDate(date, false);
    }
  }
  onChangeEndDate(date) {
    const {
      onChangeEndDate
    } = this.props;
    if (onChangeEndDate) {
      onChangeEndDate(date, false);
    }
  }
  clearDisplayDate() {
    this.setState({
      displayDate: undefined
    });
  }
  focusOnElement(ref) {
    if (isElementVisible(ref)) {
      ref.focus();
    }
  }
  hiddenDoneButton() {
    const {
      formattedStartSelection,
      formattedEndSelection,
      selection
    } = this.props;
    const {
      localizedText
    } = this.state;
    const nights = selection.numberOfNights;
    const visuallyHiddenText = localizedText.hiddenDoneButton(nights, formattedStartSelection, formattedEndSelection);
    return jsx(EGDSTertiaryButton, {
      className: "hidden-done-button",
      onClick: this.onSubmitDates,
      children: visuallyHiddenText
    });
  }
  render() {
    const {
      buttonText,
      clearButtonText,
      datePickerContent,
      doneAnalytics,
      doubleMonths,
      endSelectedMsg,
      firstDayOfWeek,
      firstValidDate,
      footerText,
      formattedEndSelection,
      formattedStartSelection,
      holidays,
      labels,
      lastValidDate,
      nextPageAnalytics,
      onClearDates,
      previousPageAnalytics,
      selection,
      selectionClassNames,
      singleMode,
      startSelectedMsg,
      submitDisabled,
      updateDatePicker,
      useClearDates
    } = this.props;
    const {
      localizedText,
      displayDate
    } = this.state;
    const monthsToRender = doubleMonths ? 2 : 1;
    const isDateSelected = singleMode ? selection.start : selection.start && selection.end;
    return jsxs("div", {
      className: getClassNameList('uitk-date-picker', 'date-picker-menu'),
      ref: this.elementRef,
      children: [jsxs(EGDSLayoutFlex, {
        alignItems: "center",
        className: getClassNameList('uitk-date-picker-selection-bar', 'uitk-date-picker-selection-bar-top'),
        tag: "section",
        children: [jsx(EGDSLayoutFlexItem, {
          children: jsx(EGDSDatePickerInput, {
            cssClassNames: selectionClassNames(true),
            isDialog: false,
            onClick: this.onClickTopStart,
            selectionDate: formattedStartSelection,
            selectionDateMsg: `${labels.start} ${startSelectedMsg}`,
            selection: selection.start,
            singleMode: singleMode
          })
        }), !singleMode && jsx(EGDSLayoutFlexItem, {
          className: getClassNameList('uitk-date-picker-selection-icon'),
          children: jsx(EGDSIcon, {
            name: "arrow_forward",
            size: EGDSIconSize.SMALL
          })
        }), !singleMode && jsx(EGDSLayoutFlexItem, {
          children: jsx(EGDSDatePickerInput, {
            cssClassNames: selectionClassNames(false),
            isDialog: false,
            onClick: this.onClickTopEnd,
            selectionDate: formattedEndSelection,
            selectionDateMsg: `${labels.end} ${endSelectedMsg}`,
            selection: selection.end
          })
        })]
      }), jsx(EGDSLayoutFlex, {
        children: jsx(EGDSLayoutFlexItem, {
          children: this.hiddenDoneButton()
        })
      }), jsx(EGDSCalendar, {
        buttonText: buttonText,
        datePickerContent: datePickerContent,
        firstMonth: selection.start || firstValidDate,
        monthsToRender: monthsToRender,
        isDialog: false,
        selection: selection,
        selectionStart: selection.start,
        selectionEnd: selection.end,
        startDate: firstValidDate,
        endDate: lastValidDate,
        updateDatePicker: updateDatePicker,
        displayDate: displayDate,
        clearDisplayDate: this.clearDisplayDate,
        firstDayOfWeek: firstDayOfWeek,
        singleMode: singleMode,
        nextPageAnalytics: nextPageAnalytics,
        previousPageAnalytics: previousPageAnalytics,
        holidays: holidays,
        onChangeMonth: this.onChangeMonth,
        onChangeStartDate: this.onChangeStartDate,
        onChangeEndDate: this.onChangeEndDate
      }), jsxs(EGDSLayoutFlex, {
        className: getClassNameList('uitk-date-picker-menu-footer'),
        children: [(footerText || selection.holidaysConfigured && selection.holidaysName !== '') && [jsx(EGDSLayoutFlexItem, {
          className: getClassNameList('uitk-date-picker-footer-text'),
          children: jsxs("div", {
            children: [selection.holidaysConfigured && selection.holidaysName !== '' && jsx("p", {
              children: selection.holidaysName
            }, "holiday"), footerText && jsx("p", {
              children: footerText
            }, "legal")]
          })
        }, "0")], jsx(EGDSLayoutFlexItem, {
          className: getClassNameList('dialog-done'),
          shrink: 0,
          children: jsxs("div", {
            children: [useClearDates && jsx(EGDSSpacing, {
              margin: {
                inline: 'three'
              },
              children: jsx(EGDSTertiaryButton, {
                "aria-label": localizedText.clearInstructions(),
                disabled: !isDateSelected,
                onClick: onClearDates,
                "data-stid": "clear-date-picker",
                children: clearButtonText
              })
            }), jsx(EGDSPrimaryButton, {
              "aria-label": localizedText.doneInstructions(),
              analytics: doneAnalytics,
              onClick: this.onSubmitDates,
              "data-stid": "apply-date-picker",
              disabled: submitDisabled,
              children: buttonText
            })]
          })
        })]
      })]
    });
  }
}
const EGDSDatePickerMenuView = props => {
  const l10n = useLocalization();
  return jsx(DatePickerMenuView, {
    l10n: l10n,
    ...props
  });
};
EGDSDatePickerMenuView.displayName = 'EGDSDatePickerMenuView';
const EGDSNewDatePickerMenuView = EGDSDatePickerMenuView;
export { EGDSDatePickerMenuView, EGDSNewDatePickerMenuView };